/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Title_SummaryInputs */

const en_us2_workout_after_title_summary = /** @type {(inputs: Workout_After_Title_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout summary`)
};

const pt_br2_workout_after_title_summary = /** @type {(inputs: Workout_After_Title_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumo do treino`)
};

const es_419_workout_after_title_summary = /** @type {(inputs: Workout_After_Title_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen del entrenamiento`)
};

const pt_pt2_workout_after_title_summary = /** @type {(inputs: Workout_After_Title_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumo do treino`)
};

const fr_fr2_workout_after_title_summary = /** @type {(inputs: Workout_After_Title_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résumé de la séance`)
};

const de_de2_workout_after_title_summary = /** @type {(inputs: Workout_After_Title_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainingszusammenfassung`)
};

const it_it2_workout_after_title_summary = /** @type {(inputs: Workout_After_Title_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Riepilogo dell'allenamento`)
};

/**
* | output |
* | --- |
* | "Workout summary" |
*
* @param {Workout_After_Title_SummaryInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_title_summary = /** @type {((inputs?: Workout_After_Title_SummaryInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Title_SummaryInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_title_summary(inputs)
	if (locale === "es-419") return es_419_workout_after_title_summary(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_title_summary(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_title_summary(inputs)
	if (locale === "de-DE") return de_de2_workout_after_title_summary(inputs)
	if (locale === "it-IT") return it_it2_workout_after_title_summary(inputs)
	return en_us2_workout_after_title_summary(inputs)
});
export { workout_after_title_summary as "workout-after.title_summary" }